import { FC } from 'react';
import usePerformanceSection from './PerformanceSection.hook';
import {
  performanceSectionStyles,
  performanceTitleStyles,
  performanceGridStyles,
  performanceItemStyles,
  performanceHeaderCellStyles,
  statusBadgeStyles,
} from './PerformanceSection.styles';
import { PerformanceSectionProps } from './PerformanceSection.types';
import Box from 'yoda-ui/components/Box';

const PerformanceSection: FC<PerformanceSectionProps> = (props) => {
  const { columns, getStatusLabel, t } = usePerformanceSection(props);

  return (
    <Box sx={ performanceSectionStyles }>
      <Box sx={ performanceTitleStyles }>
        { t('performance_section_title') }
      </Box>
      <Box sx={ performanceGridStyles }>
        {
          columns.map((column) => (
            <Box key={ column.key } sx={ performanceItemStyles }>
              <Box sx={ performanceHeaderCellStyles }>
                { column.label }
              </Box>
              <Box sx={ statusBadgeStyles(column.status) }>
                { column.customValue || getStatusLabel(column.status, column.useYesNo) }
              </Box>
            </Box>
          ))
        }
      </Box>
    </Box>
  );
};

export default PerformanceSection;
